import { Component, Input, OnInit } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PasswordService } from '@cargos/sprintpay-services';
import { CustomPatterns, CustomValidators } from '@cargos/sprintpay-utils';
import { finalize } from 'rxjs';
import { CurrentFacilityService } from 'src/app/shared/services';
import Swal from 'sweetalert2';
import { PasswordRecoveryFormErrorJSON, PasswordRecoveryFormGroupType } from './models/password-recovery-form';
import { formPasswordRecoveryErrors } from './utils/form-errors';

@Component({
    selector: 'app-sprintpay-password-recovery',
    templateUrl: './password-recovery.component.html',
    styleUrls: ['./password-recovery.component.scss'],
    standalone: false,
})
export class RecoveryPasswordComponent implements OnInit {
    private facility: string;
    public formRecoveryPassword: PasswordRecoveryFormGroupType;
    public formErrors: PasswordRecoveryFormErrorJSON;
    @Input() widthLogo = '156px';
    @Input() heightLogo = '';

    constructor(
        private fb: NonNullableFormBuilder,
        private currentFacilityService: CurrentFacilityService,
        private passwordService: PasswordService,
        private router: Router
    ) {
        this.formErrors = formPasswordRecoveryErrors;
    }

    ngOnInit(): void {
        this.facility = this.currentFacilityService.getFacilitySource();
        this.createForm();
    }

    createForm(): void {
        this.formRecoveryPassword = this.fb.group({
            email: ['', [Validators.required, CustomValidators.regex(new RegExp(CustomPatterns.EMAIL))]],
        });
    }

    recoveryPassword(event, form): void {
        event.preventDefault();
        const sub = this.passwordService
            .recoveryPassword(form, this.facility)
            .pipe(finalize(() => sub.unsubscribe()))
            .subscribe({
                next: () => {
                    Swal.fire({
                        html: `<img src='assets/${this.facility}/img/sent-email.svg' style="width:40%; margin: 3rem;"></img>
                        <p style="font-weight:400; font-size: 18px;">We sent you an email with instructions on how to reset your password</p>
                        `,
                        text: 'We sent you an email with instructions on how to reset your password',
                        showConfirmButton: true,
                        confirmButtonText: 'Ok',
                        customClass: {
                            confirmButton: 'w-100',
                            actions: 'w-100 px-3',
                        },
                        allowOutsideClick: false,
                    }).then(() => {
                        this.router.navigate(['../login']);
                    });
                },
            });
    }

    signIn(): void {
        this.router.navigate(['../login']);
    }
}
